import { render } from "./post_status_form.vue?vue&type=template&id=59414186"
import script from "./post_status_form.js?vue&type=script&lang=js"
export * from "./post_status_form.js?vue&type=script&lang=js"

import "./post_status_form.vue?vue&type=style&index=0&id=59414186&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__